import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
import { Card, CardContent } from './Card';
const REVIEWS = [{
  name: 'Michael T.',
  location: 'Gilbert, AZ',
  text: 'Joel Reynolds completely transformed our driveway and walkways. They removed years of oil stains and dirt. The crew was professional and the price was exactly what they quoted.',
  service: 'Driveway Cleaning'
}, {
  name: 'Sarah J.',
  location: 'Scottsdale, AZ',
  text: 'I was worried about pressure washing our stucco home, but their soft wash method was perfect. The house looks brand new, and they were incredibly careful around my landscaping.',
  service: 'House Soft Wash'
}, {
  name: 'David R.',
  location: 'Peoria, AZ',
  text: 'Showed up on time, worked efficiently, and the results speak for themselves. Best exterior cleaning service I have used in the Valley. Highly recommend these guys.',
  service: 'Pool Deck & Patio'
}, {
  name: 'Amanda L.',
  location: 'Phoenix, AZ',
  text: 'They cleaned our commercial storefront and the difference is night and day. Customers have actually commented on how clean the building looks. We set up a recurring schedule.',
  service: 'Commercial Wash'
}];
export function Reviews() {
  return <section id="reviews" className="py-24 bg-surface border-y border-accent/10 overflow-hidden" data-id="element-181">
      <div className="container mx-auto px-4" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-184">
            Industrial <span className="text-accent" data-id="element-185">Reviews</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-186">
            Do not just take our word for it. See what your neighbors are saying
            about our service.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-12" data-id="element-187">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-188">
            <CarouselContent className="-ml-4" data-id="element-189">
              {REVIEWS.map((review, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-190">
                  <Card className="bg-dark border-accent/20 h-full relative overflow-hidden group" data-id="element-191">
                    <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-192">
                      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-193">
                        <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#dc2626" data-id="element-194" />
                      </svg>
                    </div>
                    <CardContent className="p-6 flex flex-col h-full relative z-10" data-id="element-195">
                      <div className="flex gap-1 mb-4" data-id="element-196">
                        {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-accent-light text-accent-light" data-id="element-197" />)}
                      </div>
                      <Quote className="h-8 w-8 text-accent/30 mb-4" data-id="element-198" />
                      <p className="text-slate-300 mb-6 flex-grow italic" data-id="element-199">
                        "{review.text}"
                      </p>
                      <div className="mt-auto border-t border-accent/20 pt-4" data-id="element-200">
                        <p className="font-bold text-white" data-id="element-201">{review.name}</p>
                        <div className="flex justify-between items-center mt-1" data-id="element-202">
                          <p className="text-sm text-slate-400" data-id="element-203">
                            {review.location}
                          </p>
                          <span className="text-xs font-bold text-accent uppercase tracking-wider bg-surface px-2 py-1 rounded" data-id="element-204">
                            {review.service}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="bg-dark border-accent/30 text-white hover:bg-accent hover:text-white -left-4 md:-left-12" data-id="element-205" />
            <CarouselNext className="bg-dark border-accent/30 text-white hover:bg-accent hover:text-white -right-4 md:-right-12" data-id="element-206" />
          </Carousel>
        </div>
      </div>
    </section>;
}